import React, {useEffect} from 'react';
import '../../css/gardenManagerStylings/GardenManagerSidebarRecentActivityStyling.css'

const GardenManagerSidebarRecentActivityComponent = ({selectedGarden}) => {
    const [allActivities, setAllActivities] = React.useState([]);
    const [recentActivity, setRecentActivity] = React.useState([]);

    // Fetch all activities once on mount
    useEffect(() => {
        const fetchRecentActivities = async () => {
            try {
                const activityResponse = await fetch('/api/activities/fetchRecentActivities');
                const activityResult = await activityResponse.json();

                // Check the HTTP response status, not a property in the JSON
                if (!activityResponse.ok) {
                    console.error('Failed to fetch recent activity:', activityResult.error);
                    return;
                }

                // Check if the API returned success: true
                if (!activityResult.success) {
                    console.error('API returned error:', activityResult.error);
                    return;
                }

                setAllActivities(activityResult.data);

            } catch (error) {
                console.error('Fetch error:', error);
            }
        }

        fetchRecentActivities();
    }, []); // Only run once on mount

    // Filter activities when selectedGarden changes
    useEffect(() => {
        if (!selectedGarden || !selectedGarden.id) {
            setRecentActivity([]);
            return;
        }

        const thinnedRecentEvents = allActivities.filter(activity =>
            activity.garden_id !== null && activity.garden_id === selectedGarden.id
        );

        setRecentActivity(thinnedRecentEvents);
    }, [selectedGarden, allActivities]); // Run when garden or activities change

    useEffect(() => {
        console.log(selectedGarden);
        console.log('Recent activities:', recentActivity);
    }, [recentActivity, selectedGarden]);

    return (
        <div>
            {recentActivity.length > 0 ? (
                <div className={`recent-activities-preview`}>
                    {recentActivity.slice(0, 5).map((activity, index) => (
                        <div className="recent-activity-card" datatype={activity.event_type.toLowerCase()} key={activity.id || index}>
                            <div className={`recent-activity-action`}>{activity.event_type.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}</div>
                            <div className={`recent-activity-date-time`}>{new Date(activity.created_at).toLocaleString()}</div>
                            <div className={`recent-activity-notes`}>{activity.event_details.notes}</div>
                        </div>
                    ))}
                </div>
            ) : (
                // <div className={`no-recent-activities-message`}>
                <div className="no-entries-message">
                    <p>No recent activities</p>
                </div>
            )}
        </div>
    )
}

export default GardenManagerSidebarRecentActivityComponent;